"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var children_1 = require("./children");
var filter_1 = require("./filter");
var parent_1 = require("./parent");
exports.prev = function (target, selector) {
    var p = parent_1.parent(target);
    if (p === undefined) {
        return undefined;
    }
    var siblings = children_1.children(p);
    var index = siblings.indexOf(target);
    var candidates = filter_1.filter(siblings.slice(0, index).reverse(), selector);
    if (candidates.length > 0) {
        return candidates[0];
    }
    return undefined;
};
